import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-notes.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-notes.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { SharedConstants } from "../../shared/constants/shared.constants";
import { CreateApplicationNotesConstants } from "./create-application-notes.constant";
import { AflaModuleStrategyService } from "../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../app-controller.service";
import { NoteHeadingEnum } from "./model/note-header.model";
import { SelectedApplicationService } from "../../shared/services/selected-application/selected-application.service";
import { ApplicationCreateService } from "../shared/application-create.service";
import { CRUDOperation } from "../../shared/models/crud-operation-enum.model";
let CreateApplicationNotesComponent = class CreateApplicationNotesComponent {
    aflaModuleStrategyService;
    appControllerService;
    applicationCreateService;
    selectedApplicationService;
    changeDetectorRef;
    noteForm;
    tableHeader;
    dataSource;
    defaultSortColumn = { column: NoteHeadingEnum.date, direction: "desc" };
    deleteLabel = SharedConstants.DELETE_LABEL;
    addNotePlaceHolderText = SharedConstants.ADD_NOTE_PLACEHOLDER;
    addNoteLabel = CreateApplicationNotesConstants.ADD_NOTE_LABEL;
    noteCharacterLimit = SharedConstants.NOTE_CHARACTER_LIMIT;
    addLabel = SharedConstants.ADD_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    noteFormControlName = CreateApplicationNotesConstants.NOTE_FORM_CONTROL_NAME;
    selectedApplicationEcSubscription;
    applicationCreateServiceSelectModuleSubscription;
    stepHeader = "";
    getNotesSubscription;
    constructor(aflaModuleStrategyService, appControllerService, applicationCreateService, selectedApplicationService, changeDetectorRef) {
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appControllerService = appControllerService;
        this.applicationCreateService = applicationCreateService;
        this.selectedApplicationService = selectedApplicationService;
        this.changeDetectorRef = changeDetectorRef;
    }
    ngOnInit() {
        this.initForm();
        this.getStepHeadingSubscribers();
        this.subscribeToSelectedApplication();
    }
    initForm() {
        this.noteForm = this.aflaModuleStrategyService.form.get("notesForm");
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationEcSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application && application.id > 0) {
                this.getNotes(application);
            }
        });
    }
    populateForm(notes) {
        if (notes && notes.length > 0) {
            const idControl = this.noteForm.get("id");
            const notesControl = this.noteForm.get(this.noteFormControlName);
            notesControl.setValue(notes[notes.length - 1].note);
            idControl.setValue(notes[notes.length - 1].id);
        }
        this.changeDetectorRef.detectChanges();
    }
    getStepHeadingSubscribers() {
        this.applicationCreateServiceSelectModuleSubscription = this.applicationCreateService.selectedModuleNameAsObservable.subscribe((modName) => {
            const header = `${CreateApplicationNotesConstants.STEP_TITLE}`;
            this.stepHeader = header[0].toUpperCase() + header.substr(1).toLowerCase();
            this.changeDetectorRef.markForCheck();
        });
    }
    getNotes(application) {
        const params = {
            $filter: `jobId eq ${application.jobId} and deleted eq false`
        };
        this.getNotesSubscription = this.applicationCreateService.getNotesObservable(params).subscribe({
            next: (notes) => {
                this.populateForm(notes);
            },
            error: err => this.appControllerService.handleServerErrorMessage("getNotes", err, CRUDOperation.Get)
        });
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: ApplicationCreateService },
        { type: SelectedApplicationService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationNotesComponent = __decorate([
    Component({
        selector: "app-create-application-notes",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationNotesComponent);
export { CreateApplicationNotesComponent };
